module.exports = __webpack_public_path__ + "c76b208b006182fc6fd5e51cead89bb4.png";